import { render, staticRenderFns } from "./modGroupDetails.vue?vue&type=template&id=c39be0c6&scoped=true"
import script from "./modGroupDetails.vue?vue&type=script&lang=js"
export * from "./modGroupDetails.vue?vue&type=script&lang=js"
import style0 from "./modGroupDetails.vue?vue&type=style&index=0&id=c39be0c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39be0c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c39be0c6')) {
      api.createRecord('c39be0c6', component.options)
    } else {
      api.reload('c39be0c6', component.options)
    }
    module.hot.accept("./modGroupDetails.vue?vue&type=template&id=c39be0c6&scoped=true", function () {
      api.rerender('c39be0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/bulkUpdate/modGroupDetails.vue"
export default component.exports